import styled from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { flexColumn } from '@/styles/common';

export const Wrapper = styled.div`
  ${flexColumn}
  gap: 10px;
`;

export const SearchInputWrapper = styled.div<{ $isFocused: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1.5px solid
    ${({ $isFocused }) =>
      $isFocused ? 'var(--system-yellow)' : 'var(--border-main)'};
  border-radius: 16px;
  padding: 12px 15px;
  background: var(--bg-main);
  transition: all 0.3s ease;

  svg {
    color: var(--textAndLabels-tertiary);
  }
`;

export const SearchInput = styled.input`
  font-size: 15px;
  border: none;
  outline: none;
  background: none;
  flex: 1;
  color: var(--textAndLabels-main);

  &::placeholder {
    color: var(--textAndLabels-tertiary);
  }
`;

export const RegionsContainer = styled.div`
  ${flexColumn}
  max-height: 160px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    background-color: transparent;
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    width: 4px;
    height: 59px;
    border-radius: 7px;
    background-color: #b1b8c6;
  }
`;

export const RegionItem = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
`;

export const RegionLabel = styled(Typography).attrs({ variant: 'body3' })`
  flex: 1;
`;

export const ClearButton = styled.button`
  all: unset;
  display: flex;
  cursor: pointer;

  & > svg {
    width: 13px;
    height: 13px;
  }
`;
